import { apiService } from './apiService';
import type { ApproveBidDto, Bid, PlaceBidDto } from '@/types/bid';
import type { UserBidItem } from '@/types/userBids';
import { i18n } from '@/locales';

export const bidsApi = {
  async getBids(saleItemId: string): Promise<Bid[]> {
    return apiService.get<Bid[]>(`/bids?saleItemId=${ saleItemId }`);
  },

  async getApprovedBids(saleItemId: string): Promise<Bid[]> {
    return apiService.get<Bid[]>(`/bids/approved?saleItemId=${ saleItemId }`);
  },

    async getUserBids(): Promise<UserBidItem[]> {
        const lang = i18n.language;
        return apiService.get<UserBidItem[]>(`/bids/user/my-bids?lang=${ lang }`);
    },

  async placeBid(bidData: PlaceBidDto): Promise<Bid> {
    return apiService.post<PlaceBidDto, Bid>('/bids', bidData);
  },

  async approveBid(bidId: string, approveData: ApproveBidDto): Promise<Bid> {
    return apiService.put<ApproveBidDto, Bid>(`/bids/${ bidId }/approve`, approveData);
  },

  async rejectBid(bidId: string): Promise<Bid> {
    return apiService.put<undefined, Bid>(`/bids/${ bidId }/reject`);
  },
};
